import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import appIcon from '../../assets/iconW.svg'; 
import './LoginPage.css';
import cornerBg from '../../assets/murjelm.png'; 

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const LoginPage = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault(); 
    setErrorMsg(''); 
    setIsLoading(true); 

    try {
      const response = await fetch(`${API_BASE}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const result = await response.json();

      if (!response.ok) {
        setErrorMsg(result.detail || 'Invalid email or password');
        return;
      }

      localStorage.setItem('murjan_token', result.access_token);
      localStorage.setItem('murjan_user', JSON.stringify(result.user));
      navigate('/dashboard'); 
    } catch (error) {
      setErrorMsg('Unable to connect to the authentication server');
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <div className="login-page-wrapper">
      <img src={cornerBg} alt="Background decoration" className="corner-image" />
      <div className="login-container">
        <img src={appIcon} alt="App icon" className="app-logo" onClick={() => navigate('/')}/>
        <h1>Welcome Back</h1>

        <form className="login-form" onSubmit={handleLogin}>
          <input type="email" placeholder="Email Address" value={email} onChange={(e) => setEmail(e.target.value)}
            required />
          <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required/>
          <p className="forgot-password" onClick={() => navigate('/forget-password')}>
            Forget Password?
          </p>
          {errorMsg && (
            <p style={{ color: '#EA6C52', margin: '0 0 15px 0', fontSize: '14px', textAlign: 'left' }}>
              {errorMsg}
            </p>
          )}
          <button className="submit" type="submit" disabled={isLoading}>
            {isLoading ? 'Authenticating...' : 'Sign In'}
          </button>
        </form>
        
        <p className="signup">
          Don't have an account?{' '}
          <span onClick={() => navigate('/register')}>Create new account</span>
        </p>
      </div>
    </div>
  );
}

export default LoginPage;
